import _ from 'underscore';

angular.module('am4').controller('createUserCtrl', function(
    $scope,
    $state,
    users,
    config,
    $translate,
    tagService,
    errorService,
    ngDialog) {

    var that = this;

    that.newUser = {};
    that.savingUser = false;
    that.initVisibleNumberUiSelectChoices = 20;
    that.visibleNumberUiSelectChoices = that.initVisibleNumberUiSelectChoices;

    $scope.$on('uiSelectInfiniteScroll:resetLimit', function() {
        that.visibleNumberUiSelectChoices = that.initVisibleNumberUiSelectChoices;
    });

    that.showMoreUiSelectChoices = function() {
        that.visibleNumberUiSelectChoices += that.initVisibleNumberUiSelectChoices;
    };


    // User Details
    that.createUserForm = {};
    that.languages = config.languages;
    that.units = config.units;
    that.availableRoles = config.userRoles;

    that.createUser = function() {
        that.savingUser = true;
        that.newUser.tags = [...that.newUser.tags, ...that.newUserCopyTags];

        users.createUser(that.newUser)
        .then(function(res) {
            $state.go('app.am4.user', { id: res.data.id });
        })
        .catch(function(e) {
            errorService.addError('CREATE_USER_ERROR', e);
        })
        .finally(function() {
            that.savingUser = false;
        });
    };

    that.filterRoles = function(searchQuery) {
        return function(role) {
            if (!searchQuery) {
                return true;
            }

            return $translate.instant(role.toUpperCase()).toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1;
        };
    };

    // User Tags
    that.newUser.tags = [];
    that.newUserCopyTags = [];
    that.availableTagsLoaded = false;
    that.availableTags = null;

    tagService.getAvailableTags().then(function(tags) {
        that.availableTags = tags;
        that.availableTagsLoaded = true;
    });

    that.addTag = function() {
        that.newUser.tags.push(
            {
                type: 'organization',
                tag_id: '',
                name: ''
            }
        );
    };

    that.openCopyTagModal = function() {
        const dialog = ngDialog.open({
            template: require('../views/modal/copyTag.html'),
            plain: true,
            controller: ['$scope', 'ngDialog', function($scope, ngDialog) {
                var id = ngDialog.getOpenDialogs()[0];
                $scope.copyUserSearch = '';
                $scope.userToCopy = null;
                $scope.copyableUsers = [];
                $scope.resultsLoaded = false;

                $scope.$watch('copyUserSearch',
                    _.debounce(function(search) {
                        users.query({
                            search: search
                        }).then((res) => {
                            $scope.copyableUsers = res.data;
                            if ($scope.copyUserSearch) {
                                $scope.resultsLoaded = true;
                            } else {
                                $scope.resultsLoaded = false;
                            }
                        });
                    }, 250)
                );

                $scope.selectUser = (id) => {
                    $scope.userToCopy = id;
                };

                $scope.submit = () => {
                    tagService.getUserTags(`auth0|asset_management_${$scope.userToCopy}`)
                    .then(res => {
                        ngDialog.close(id, { userTags: res });
                    })
                    .catch(() => {
                        ngDialog.close(id, { userTags: [] });
                    });
                };
            }]
        });

        dialog.closePromise.then((data) => {
            that.newUserCopyTags = fixTagNames(data.value.userTags, that.availableTags)
            .map((t) => {
                return {
                    type: t.tag_type.toLowerCase(),
                    tag_id: t.tag_id,
                    name: t.tag_name
                };
            });
        });
    };

    that.removeCopyTag = function(index) {
        that.newUserCopyTags.splice(index, 1);
    };

    that.removeTag = function(index) {
        that.newUser.tags.splice(index, 1);
    };

    function fixTagNames(userTags, availableTags) {
        return _.map(userTags, userTag => {
            var matches = _.map(availableTags.types, type => {
                return _.findWhere(availableTags.tags[type.value], { tag_id: +userTag.tag_id });
            });

            matches = _.filter(matches, item => !!item);
            if (matches.length) {
                userTag.tag_name = matches[0].name;
            }

            return userTag;
        });
    }
});



// WEBPACK FOOTER //
// ./src/app/controllers/createUserCtrl.js